module.exports = __webpack_public_path__ + "img/derivePdfWhite.44e328a3.svg";